import { render } from "./RouteByTrainBus.vue?vue&type=template&id=2b1f1403&scoped=true"
import script from "./RouteByTrainBus.vue?vue&type=script&lang=js"
export * from "./RouteByTrainBus.vue?vue&type=script&lang=js"

import "./RouteByTrainBus.vue?vue&type=style&index=0&id=2b1f1403&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1f1403"]])

export default __exports__